import {
  canShowBySuppressionKey,
  suppressBySuppressionKey,
} from '../../../shared/services/localStorageSuppression';

export const UNIVERSITY_EMAIL_VERIFY_PROMPT_KEY =
  'universityEmailVerifyPromptSuppressedUntil';

export const DEFAULT_SUPPRESSION_DAYS = 1;

export const canShowUniversityEmailVerifyPrompt = (
  now: Date = new Date(),
): boolean => canShowBySuppressionKey(UNIVERSITY_EMAIL_VERIFY_PROMPT_KEY, now);

export const suppressUniversityEmailVerifyPrompt = (
  days: number = DEFAULT_SUPPRESSION_DAYS,
  now: Date = new Date(),
): void =>
  suppressBySuppressionKey(UNIVERSITY_EMAIL_VERIFY_PROMPT_KEY, days, now);
